import { configureStore } from "@reduxjs/toolkit";
import survey from "./pages/surveyBuilder/surveySlice";
import auth from "./pages/auth/authSlice";
import result from "./pages/workspace/results/resultSlice";
import action from "./pages/workspace/actionPlan/actionSlice";

export const store = configureStore({
   reducer: { auth, survey, result, action }
});
